import React, { useContext, useEffect } from 'react';
import { MFBeaconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { FlowContext } from '../../core/flow-engine';
import { withDefault } from '../../core/util';
import { accountTypes } from '../../flows/shared/utils';
import { modalCloseNextModalHandler } from '../Modal/utils';
import { filterAgreementOwners, handleBuyFlowRouting } from './utils';
import { dispatchOverlayLoad } from '../../analytics/analytics-helper';
import styles from './style.css';

const ExistingAgreementsWarnModal = () => {
  const { appState, closeNextModal } = useContext(FlowContext);
  const agreementType = withDefault(appState.store.accountType);
  const profileApplicationID = withDefault(
    appState.store.app?.profileApplicationID,
    ''
  );
  const usersExistingAgreements = withDefault(
    appState.store.existingAgreements,
    []
  );

  const isMinorAccount = agreementType === accountTypes.UGMAUTMA;

  /* retrieve and set additional owners for reference */
  const agreementOwnerParties = usersExistingAgreements.flatMap(
    ele => ele.agreementParties
  );

  const filteredOwners = filterAgreementOwners(
    agreementOwnerParties,
    isMinorAccount
  );

  /* MODAL CONTENT */
  const articleText1 = isMinorAccount ? 'an' : 'a';
  const articleText2 = isMinorAccount ? 'for ' : 'with ';
  const accountDisplayName = isMinorAccount ? 'UGMA/UTMA' : 'joint';
  // map account owner names array to text and replace the comma before last name
  const accountOwnerNames = filteredOwners
    ?.map(name => name)
    ?.toString()
    ?.replace(`, and`, ` and`);

  const modalTitle = `You already have ${articleText1} ${accountDisplayName} account ${articleText2}${accountOwnerNames}.`;
  const minorModalInstructions = `To open a new ${accountDisplayName} account for a different minor, select Edit Application.`;
  const jointOwnerModalInstructions = `To open a new ${accountDisplayName} account with additional or different co-owners on your application, select Edit Application.`;
  const modalInstructions = `To add new positions to your existing ${accountDisplayName} account, select Add New Mutual Fund(s).`;

  useEffect(() => {
    // Send analytics the modal overlay state
    dispatchOverlayLoad('Account Already exists');
  }, []);

  return (
    <MFBeaconModal open removeCloseButton data-metrics-location="PU">
      <div className="beacon-modal__title">{modalTitle}</div>
      <div className="beacon-modal__description">
        {isMinorAccount ? (
          <p>{minorModalInstructions}</p>
        ) : (
          <p>{jointOwnerModalInstructions}</p>
        )}
        <p>{modalInstructions}</p>
      </div>

      <div className="modal-btn-container">
        <MFBeaconButton
          role="button"
          id="existingAgreeWarnModalContinueBtn"
          data-name="existingAgreeWarnModalContinueBtn"
          variant="secondary"
          onClick={() => handleBuyFlowRouting(profileApplicationID)}
          label="Add New Mutual Funds(s)"
        />
        <MFBeaconButton
          role="button"
          id="existingAgreeWarnModalEditAppBtn"
          data-name="existingAgreeWarnModalEditAppBtn"
          variant="primary"
          onClick={() => modalCloseNextModalHandler(closeNextModal)}
          label="Edit Application"
        />
      </div>
      <style jsx="true">{styles}</style>
    </MFBeaconModal>
  );
};

export default ExistingAgreementsWarnModal;
